import React from 'react'
import Badge from 'react-bootstrap/Badge'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

/**
 * Consolidated icon badge with tooltip. Replaces ConflictBadge, HighRiskPermissionBadge,
 * SuperUserPermissionBadge, and InternalConflict badges.
 *
 * @param {object} props
 * @param {import('@fortawesome/fontawesome-svg-core').IconProp} props.icon - FontAwesome icon
 * @param {string} props.iconColor - CSS class for icon color (e.g. 'text-warning', 'text-danger')
 * @param {string} props.textColor - CSS class for text color (default: 'text-primary')
 * @param {string} props.tooltipText - Tooltip content
 * @param {string} [props.tooltipPlacement] - Tooltip placement (default: 'top')
 * @param {number|string} [props.count] - Numeric count to display
 * @param {string} [props.text] - Text to display (used if count not provided)
 * @param {string} [props.className] - Additional CSS classes
 */
const IconBadge = ({
  icon,
  iconColor = 'text-primary',
  textColor = 'text-primary',
  tooltipText,
  tooltipPlacement = 'top',
  count,
  text,
  className = '',
  ...props
}) => {
  const displayText = count !== undefined && count !== null ? count : text

  const badge = (
    <Badge
      pill
      className={`bg-light ${textColor} ${className}`.trim()}
      style={{ cursor: tooltipText ? 'pointer' : undefined }}
      {...props}
    >
      <FontAwesomeIcon icon={icon} className={iconColor !== textColor ? iconColor : undefined} />{' '}
      {displayText}
    </Badge>
  )

  if (tooltipText) {
    return (
      <OverlayTrigger
        placement={tooltipPlacement}
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>{tooltipText}</Tooltip>}
      >
        {badge}
      </OverlayTrigger>
    )
  }

  return badge
}

export default IconBadge
